/**
 * Global font variables
 */
export const baseFontSize = 16;

//  Example Font Family
export const fontRegular = 'AvenirNextLTPro-Regular,arial,helvetica,verdana,sans-serif';
export const fontMedium = 'AvenirNextLTPro-Medium,arial,helvetica,verdana,sans-serif';
export const fontBold = 'AvenirNextLTPro-Demi,arial,helvetica,verdana,sans-serif';
